import React from 'react';
import PropTypes from 'prop-types';
import { withHandlers } from 'recompose';
import classnames from 'classnames';
import { Field } from 'redux-form';

import { Link } from 'components/core/Link';
import { FormItem, FormGroup, TextInput } from 'components/core/Form';

import './AlternateNamesContainer.scss';

export const enhance = withHandlers({
	removeField: ({ fields }) => (index) => {
		fields.remove(index);
	},
	addField: ({ fields }) => () => {
		fields.push({ key: fields.length + 1 });
	}
});

export function AlternateNamesContainer({
	className,
	fields,
	addField,
	removeField,
	text
}) {
	return (
		<div className={classnames('alternate-names-container', className)}>
			{fields && fields.map((member, index) => (
				<div className="alternate-name-row" key={`${member}.key`}>
					<FormGroup>
						<FormItem>
							<Field
								name={`${member}.firstName`}
								id={`alternativeFirstName-${index}`}
								label="Alternate First Name"
								component={TextInput}
							/>
						</FormItem>
						<FormItem>
							<Field
								name={`${member}.lastName`}
								id={`alternativeLastName-${index}`}
								label="Alternate Last Name"
								component={TextInput}
							/>
						</FormItem>
					</FormGroup>
					<Link
						onClick={() => removeField(index)}
						className="btn-remove-alternate-name"
					>
						Remove
					</Link>
				</div>
			))}
			{fields && fields.length > 0 &&
			<br />
			}
			<Link
				className="btn-add-alternate-name"
				onClick={addField}
			>
				{text}
			</Link>
		</div>
	);
}

AlternateNamesContainer.propTypes = {
	className: PropTypes.string,
	fields: PropTypes.object,
	addField: PropTypes.func,
	removeField: PropTypes.func,
	text: PropTypes.string
};

AlternateNamesContainer.defaultProps = {
	text: 'Add another name to this reservation'
};

export default enhance(AlternateNamesContainer);
